const environment = process.env.NODE_ENV
const link = window.location.protocol + '//' + window.location.hostname
export const baseUrl = environment === 'production' ? 'https://server2.savor.vn' : link + ':8002'
// export const baseUrl = environment === 'production' ? 'http://192.168.31.161' : link + ':8002'
